<template>
	<div>
		<div v-if="loading">
			<div class="success--text text-h4 text-center">
				در حال دریافت اطلاعات...
			</div>
		</div>
		<div v-else>
			<div v-if="!assurances.length">
				<h3 class="text-center red--text">تضمینی برای این وام ثبت نشده است</h3>
				<div class="text-center mt-5">
					<v-btn class="mx-auto" color="green" dark @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن تضمین
					</v-btn>
				</div>
			</div>
			<div v-else>
				<v-card v-for="(assurance, index) in assurances" :key="assurance.id + index" class="mb-8" elevation="0" style="border: 1px solid #ddd">
					<v-form :ref="'form' + index" lazy-validation @submit.prevent="save(assurance, index)">
						<div class="pa-2 d-flex align-center" style="border-bottom: 1px solid #ddd;background-color: #eee;">
							<span class="ml-1">نوع ضمانت:</span>
							<div>
								<v-btn-toggle :disabled="true" v-model="assurance.assuranceType" tile x-small outlined color="secondary">
									<v-btn :value="1">
										سازمانی - خودم
									</v-btn>

									<v-btn :value="2">
										سازمانی - شخص دیگر
									</v-btn>

									<v-btn :value="3">
										چــک
									</v-btn>

									<v-btn :value="4">
										طــلا
									</v-btn>

									<v-btn :value="0">
										سایر
									</v-btn>
								</v-btn-toggle>
							</div>
						</div>
						<v-row>
							<v-col cols="12" :md="assurance.assuranceType === 3 ? 12 : 9">
								<v-card-text class="pt-6">
									<div v-if="!assurance.editMode">
										<v-row v-if="assurance.assuranceType === 1 || assurance.assuranceType === 2">
											<v-col cols="12" md="8" class="py-0 my-0">
												<div>
													<small>سازمان:</small>
													<div class="grey--text"><small>{{ assurance.organization ? assurance.organization.name : 'نامشخص' }}</small></div>
													<!-- <small class="grey--text mr-1">{{ assurance.organization.name }}</small> -->
												</div>
											</v-col>
										</v-row>
										<v-row>
											<v-col cols="12" md="4" class="py-0 my-0" v-if="assurance.assuranceType === 2 || assurance.assuranceType === 3">
												<small v-if="assurance.assuranceType === 2">نام و نام خانوادگی ضامن:</small>
												<small v-if="assurance.assuranceType === 3">نام و نام خانوادگی صاحب چک:</small>
												<div class="grey--text"><small>{{ assurance.personFullName }}</small></div>
											</v-col>
											<v-col cols="12" md="4" class="py-0 my-0" v-if="assurance.assuranceType === 2 || assurance.assuranceType === 3">
												<small v-if="assurance.assuranceType === 2">کد ملی ضامن:</small>
												<small v-if="assurance.assuranceType === 3">کد ملی صاحب چک:</small>
												<div class="grey--text"><small>{{ assurance.personNationalCode }}</small></div>
											</v-col>
											<v-col cols="12" :md="assurance.assuranceType === 2 ? 4 : 8" class="py-0 my-0" v-if="assurance.assuranceType === 1 || assurance.assuranceType === 2">
												<small>شماره پرسنلی:</small>
												<div class="grey--text"><small>{{ assurance.personalCode }}</small></div>
											</v-col>
											<v-col cols="12" md="4" class="py-0 my-0" v-if="assurance.assuranceType === 2 || assurance.assuranceType === 3">
												<small v-if="assurance.assuranceType === 2">شماره موبایل ضامن:</small>
												<small v-if="assurance.assuranceType === 3">شماره موبایل صاحب چک:</small>
												<div class="grey--text"><small>{{ assurance.personMobile }}</small></div>
											</v-col>
											<v-col cols="12" md="4" class="py-0 my-0" v-if="assurance.assuranceType === 4">
												<small>وزن طلا (گرم):</small>
												<div class="grey--text"><small>{{ assurance.goldWeight }} گرم</small></div>
											</v-col>
											<v-col cols="12" class="py-0 my-0" v-if="assurance.assuranceType !== 3">
												<small>توضیحات:</small>
												<div class="grey--text" style="white-space: pre-line;font-size: 0.71rem;">
													{{ assurance.description }}
												</div>
											</v-col>
										</v-row>
										<v-row v-if="assurance.assuranceType === 3">
											<v-col cols="12">
												<div class="d-flex flex-wrap mb-2 py-2" style="border-top: 1px dashed #ddd;" v-for="cheque in assurance.assuranceChequeItems" :key="cheque.id">
													<div class="px-2" style="width: 100px">
														<ImageUploader v-model="cheque.base64" :downloadable="false" :editable="false" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(cheque.base64)" />
													</div>
													<div class="px-2">
														<div><small>تاریخ چک:</small></div>
														<div class="grey--text"><small>{{ cheque.dueDate_Persian ? cheque.dueDate_Persian.date : '' }}</small></div>
													</div>
													<div class="px-2">
														<div><small>شماره چک:</small></div>
														<div class="grey--text"><small>{{ cheque.chequeNumber }}</small></div>
													</div>
													<div class="px-2">
														<div><small>شماره صیادی:</small></div>
														<div class="grey--text"><small>{{ cheque.sayadiId }}</small></div>
													</div>
													<div class="px-2">
														<div><small>مبلغ:</small></div>
														<div class="grey--text"><small>{{ String(cheque.price).toPriceFormat() }}</small></div>
													</div>
												</div>
											</v-col>
										</v-row>
									</div>
									<div v-else>
										<v-row v-if="assurance.assuranceType === 1 || assurance.assuranceType === 2">
											<v-col cols="12" md="8" class="py-0 my-0">
												<div>
													<small>سازمان:</small>
												</div>
												<div class="d-flex">
													<v-select dense outlined return-object v-model="assurance.organization" :items="organizations" item-text="name" item-value="id" :rules="[(val) => !!val || 'سازمان را انتخاب کنید']" required>
													</v-select>
												</div>
											</v-col>
											<v-col cols="12" md="4" class="py-0 my-0 pt-7">
												<v-btn color="secondary" text x-small dark class="" @click="manageOrganizations">
													مدیریت سازمان ها
												</v-btn>
											</v-col>
										</v-row>
										<v-row>
											<v-col cols="12" md="4" class="py-0 my-0" v-if="assurance.assuranceType === 2 || assurance.assuranceType === 3">
												<small v-if="assurance.assuranceType === 2">نام و نام خانوادگی ضامن:</small>
												<small v-if="assurance.assuranceType === 3">نام و نام خانوادگی صاحب چک:</small>
												<v-text-field dense v-model="assurance.personFullName" outlined :label="''" :error-messages="errorMessages" :rules="[(val) => !!val || 'اطلاعات را وارد کنید']" />
											</v-col>
											<v-col cols="12" md="4" class="py-0 my-0" v-if="assurance.assuranceType === 2 || assurance.assuranceType === 3">
												<small v-if="assurance.assuranceType === 2">کد ملی ضامن:</small>
												<small v-if="assurance.assuranceType === 3">کد ملی صاحب چک:</small>
												<v-text-field dense maxlength="10" v-model="assurance.personNationalCode" outlined :label="''" :error-messages="errorMessages" :rules="[(val) => !!val || 'کد ملی را وارد کنید']" />
											</v-col>
											<v-col cols="12" :md="assurance.assuranceType === 2 ? 4 : 8" class="py-0 my-0" v-if="assurance.assuranceType === 1 || assurance.assuranceType === 2">
												<small>شماره پرسنلی:</small>
												<v-text-field dense v-model="assurance.personalCode" outlined :label="''" :error-messages="errorMessages" :rules="[(val) => !!val || 'کد پرسنلی را وارد کنید']" />
											</v-col>
											<v-col cols="12" md="4" class="py-0 my-0" v-if="assurance.assuranceType === 2">
												<small>شماره موبایل ضامن:</small>
												<v-text-field dense maxlength="11" v-model="assurance.personMobile" outlined :label="''" :error-messages="errorMessages" />
											</v-col>
											<v-col cols="12" md="4" class="py-0 my-0" v-if="assurance.assuranceType === 2">
												<div v-if="!assurance.mobileVerified" class="d-flex px-2 align-center">
													<v-text-field v-model="assurance.mobileOtp" maxlength="5" label="کد تایید" />
													<v-btn v-if="sendCodeVisible" small class="mr-2" @click="sendOTP(assurance.personMobile, index)" :loading="optLoading"><small>ارسال کد</small></v-btn>
													<Countdown class="black--text fs-h3" @finish="countDownFinished" ref="countdown" />
												</div>
												<div class="px-2 align-center d-flex h-100" v-else>
													<v-icon small color="success">mdi-check-circle</v-icon>
													<small class="success--text">شماره موبایل تایید شده است</small>
												</div>
											</v-col>
											<v-col cols="12" md="4" class="py-0 my-0" v-if="assurance.assuranceType === 4">
												<small>وزن طلا (گرم):</small>
												<v-text-field dense type="number" v-model="assurance.goldWeight" outlined :label="''" :error-messages="errorMessages" :rules="[(val) => !!val || 'وزن طلا را وارد کنید']" />
											</v-col>
											<v-col cols="12" class="py-0 my-0" v-if="assurance.assuranceType !== 3">
												<small>در صورت لزوم توضیحات ضمانت را وارد کنید:</small>
												<v-textarea v-model="assurance.description" rows="2" outlined :error-messages="errorMessages" label="" hint="حداکثر 1000 کاراکتر" />
											</v-col>
										</v-row>
										<div v-if="assurance.assuranceType === 3">
											<div color="#eee" style="border-bottom: 2px dashed #ddd;" class="mb-2" v-for="(cheque, index) in assurance.assuranceChequeItems" :key="cheque.id">
												<v-row>
													<v-col cols="12" md="2">
														<ImageUploader :ref="'chequeImageUploader' + cheque.id + index" v-model="cheque.base64" @change="() => { if (cheque.id !== emptyId) cheque.isChanged = true }" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(cheque.base64)" @delete="() => { if (cheque.id !== emptyId) cheque.isChanged = true; cheque.fileName = '' }" />
													</v-col>
													<v-col cols="12" md="3">
														<div>
															<div>تاریخ چک</div>
															<date-picker @change="() => { if (cheque.id !== emptyId) cheque.isChanged = true }" class="date-picker-input-sm" v-model="cheque.dueDate" format="YYYY-MM-DDTHH:mm:ss" display-format="jYYYY/jMM/jDD" :error-messages="errorMessages" auto-submit />
														</div>
													</v-col>
													<v-col cols="12" md="2">
														<v-text-field v-model="cheque.chequeNumber" @change="() => { if (cheque.id !== emptyId) cheque.isChanged = true }" label="شماره چک" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره چک را وارد کنید']" />
													</v-col>
													<v-col cols="12" md="2" class="px-0">
														<v-text-field v-model="cheque.sayadiId" @change="() => { if (cheque.id !== emptyId) cheque.isChanged = true }" label="شماره صیادی" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره صیادی را وارد کنید']" />
													</v-col>
													<v-col cols="12" md="3" class="d-flex">
														<v-text-money v-model="cheque.price" @change="() => { if (cheque.id !== emptyId) cheque.isChanged = true }" label="مبلغ چک" :error-messages="errorMessages" :rules="[() => Number(cheque.price) >= 0 || 'مبلغ چک نمی تواند کمتر از 0 باشد']" />
														<v-btn text icon small class="mt-8 mr-2" @click="removeChequeItem(assurance, index)">
															<v-icon color="red">mdi-close</v-icon>
														</v-btn>
													</v-col>
												</v-row>
											</div>
											<div class="text-center">
												<v-btn color="secondary" x-small @click="addCheque(assurance)">افزودن چک</v-btn>
											</div>
										</div>
									</div>
								</v-card-text>
							</v-col>
							<v-col cols="12" md="3" v-if="assurance.assuranceType !== 3" class="text-center d-flex flex-column justify-">
								<div class="py-1 mt-2"><small>فایل پیوست:</small></div>
								<ImageUploader :ref="'imageUploader' + assurance.id + index" :editable="!!assurance.editMode" v-model="assurance.base64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(assurance.base64)" @delete="() => assurance.fileName = ''" />
							</v-col>
						</v-row>
						<v-card-actions style="border-top: 1px dashed #ddd;">
							<div class="d-flex grey--text" v-if="(assurance.assuranceType === 3 || assurance.assuranceType === 4) && assurance.id !== emptyId">
								<div class="d-flex" v-if="assurance.isReturned">
									<v-icon x-small color="success">mdi-check</v-icon>
									<small class="ml-2">عودت شده در تاریخ و ساعت: &lrm;{{ assurance.returnDateTime_Persian.date }} {{ assurance.returnDateTime_Persian.time }}</small>
									<small class="ml-2">به {{ assurance.returnedToPerson }}</small>
								</div>
								<v-btn x-small elevation="0" color="secondary" @click.prevent="showReturnDialog(assurance)">
									ثبت عودت
								</v-btn>
							</div>
							<v-spacer></v-spacer>
							<v-btn v-if="!assurance.editMode" :loading="printLoadingId === assurance.id" outlined small color="secondary" fab @click="print(assurance)" size="small" class="mx-1">
								<v-icon>
									mdi-printer
								</v-icon>
							</v-btn>
							<v-btn v-if="!assurance.editMode" @click.prevent="edit(assurance)" class="ms-2" small fab dark color="green" title="ویراش">
								<v-icon dark>
									mdi-square-edit-outline
								</v-icon>
							</v-btn>
							<v-btn v-if="!assurance.editMode" @click="remove(assurance, index)" class="ms-2" small fab dark color="pink" title="حذف">
								<v-icon dark>
									mdi-trash-can-outline
								</v-icon>
							</v-btn>
							<v-btn class="mx-1" @click="cancel(assurance, index)" v-if="assurance.editMode" color="grey" small dark>
								انصراف
							</v-btn>
							<v-btn :loading="submitLoading" type="submit" v-if="assurance.editMode" color="secondary" small dark>
								ذخیره
							</v-btn>
						</v-card-actions>
					</v-form>
				</v-card>
				<div class="text-center mt-5">
					<v-btn class="mx-auto" color="green" dark @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن تضمین
					</v-btn>
				</div>
			</div>
		</div>

		<v-dialog v-model="organizationsDialog" scrollable max-width="700px">
			<Organizations v-if="organizationsDialog" @callbck="organizationsDialog = false" @close="organizationsDialog = false" />
		</v-dialog>

		<v-dialog v-model="returnDialog" scrollable max-width="350px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مشخصات عودت</span></div>
					<v-spacer />
					<v-btn @click="returnDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-form ref="returnform" class="mx-2" lazy-validation @submit.prevent="submitReturn">
					<v-card-text>
						<v-container>
							<v-row>
								<v-col cols="12" md="12">
									<v-switch v-model="selectedReturn.isReturned" label="عودت داده شده" color="secondary" :value="true" hide-details></v-switch>
								</v-col>
								<v-col cols="12" md="12">
									<div class="mb-1">
										<div class="ml-2">تاریخ عودت:</div>
										<div>
											<date-picker ref="saveDate" v-model="selectedReturn.returnDateTime" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD HH:mm:ss" :error-messages="errorMessages" :rules="[(val) => !!val || 'تاریخ عودت را به صورت صحیح وارد کنید']" />
										</div>
										<div class="red--text">
											{{ returnDatePickerValidatioin }}
										</div>
									</div>
								</v-col>
								<v-col cols="12" md="12">
									<div class="mb-1">
										<div class="ml-2">تحویل گیرنده:</div>
										<div>
											<v-text-field dense outlined v-model="selectedReturn.returnedToPerson" label="" :error-messages="errorMessages" :rules="[(val) => !!val || 'تحویل گیرنده الزامی است']" required />
										</div>
									</div>
								</v-col>
							</v-row>
							<v-card-actions>
								<v-spacer />
								<v-btn @click="returnDialog = false">
									بستن
								</v-btn>
								<v-btn color="secondary" dark type="submit" :loading="submitReturnLoading">
									ذخیره
								</v-btn>
							</v-card-actions>
						</v-container>
					</v-card-text>
				</v-form>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />

		<div id="printHtml" style="display: none;">
			<assurance-self-organization-printHtml v-if="selectedAssurance && selectedAssurance.assuranceType === 1" @ready="printReady = true" :assurance="selectedAssurance" />
			<assurance-other-organization-printHtml v-else-if="selectedAssurance && selectedAssurance.assuranceType === 2" @ready="printReady = true" :assurance="selectedAssurance" />
			<assurance-cheque-printHtml v-else-if="selectedAssurance && selectedAssurance.assuranceType === 3" @ready="printReady = true" :assurance="selectedAssurance" />
			<assurance-gold-printHtml v-else-if="selectedAssurance && selectedAssurance.assuranceType === 4" @ready="printReady = true" :assurance="selectedAssurance" />
		</div>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'
	import ImageUploader from '@/components/uploader/ImageUploader'
	import { call, get } from 'vuex-pathify'
	import printJS from 'print-js'

	export default {
		name: 'Assurance',
		props: {
			data: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			Organizations: () => import('@/components/forms/Organizations'),
			'assurance-self-organization-printHtml': () => import('@/components/prints/AssuranceSelfOrganizationPrintHtml'),
			'assurance-other-organization-printHtml': () => import('@/components/prints/AssuranceOtherOrganizationPrintHtml'),
			'assurance-gold-printHtml': () => import('@/components/prints/AssuranceGoldPrintHtml'),
			'assurance-cheque-printHtml': () => import('@/components/prints/AssuranceChequePrintHtml'),
			'date-picker': () => import('vue-persian-datetime-picker'),
			ImageUploader,
		},
		data() {
			return {
				emptyId: emptyId,
				overlayImgSrc: '',
				overlay: false,
				errorMessages: '',
				assurances: [],
				selectedAssurance: {},
				selectedReturn: {},
				submitLoading: false,
				loading: false,
				organizationsDialog: false,
				returnDialog: false,
				returnDatePickerValidatioin: '',
				submitReturnLoading: false,
				printReady: false,
				printLoadingId: '',
				optLoading: false,
				sendCodeVisible: true,
			}
		},
		computed: {
			organizations: get('organizations/all')
		},
		mounted() {
			this.loadData()
			this.fetchOrganizations()
		},
		methods: {
			fetchOrganizations: call('organizations/fetch'),
			loadData() {
				this.loading = true
				api.get('admin/Assurance/ListByUserLoanId/' + this.data.id, null)
					.then(
						response => {
							this.assurances = response.map(x => {
								x.editMode = false
								return x
							})
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},
			edit(assurance) {
				this.sendCodeVisible = true
				assurance.editMode = true
				assurance.original = JSON.parse(JSON.stringify(assurance))
			},
			save(assurance, index) {
				if (!this.$refs['form' + index] && !this.$refs['form' + index][0].validate())
					return
				const formData = new FormData()
				var fileUploader = Array.isArray(this.$refs['imageUploader' + assurance.id + index]) ? this.$refs['imageUploader' + assurance.id + index][0] : null
				if (fileUploader && fileUploader.hasFile()) {
					formData.append('file', fileUploader.getFile())
				}
				formData.append('id', assurance.id)
				formData.append('description', assurance.description || '')
				formData.append('userLoanModel.id', this.data.id)
				formData.append('fileName', assurance.fileName || '')
				formData.append('assuranceType', assurance.assuranceType)
				formData.append('goldWeight', assurance.goldWeight || 0)
				formData.append('isReturned', !!assurance.isReturned)
				formData.append('personFullName', assurance.personFullName || '')
				formData.append('personNationalCode', assurance.personNationalCode || '')
				formData.append('personalCode', assurance.personalCode || '')
				formData.append('personMobile', assurance.personMobile || '')
				formData.append('mobileOtp', assurance.mobileOtp || '')
				formData.append('returnedToPerson', assurance.returnedToPerson || '')
				if (assurance.returnDateTime)
					formData.append('returnDateTime', assurance.returnDateTime)
				if (assurance.organization) {
					formData.append('organization.id', assurance.organization.id)
					formData.append('organization.name', assurance.organization.name)
				}
				if (assurance.assuranceChequeItems?.length > 0) {
					for (let i = 0; i < assurance.assuranceChequeItems.length; i++) {
						let ch = assurance.assuranceChequeItems[i]
						var fileUploader = Array.isArray(this.$refs['chequeImageUploader' + ch.id + i]) ? this.$refs['chequeImageUploader' + ch.id + i][0] : null

						if (fileUploader && fileUploader.hasFile()) {
							formData.append(`assuranceChequeItems[${i}].File`, fileUploader.getFile())
						}
						formData.append(`assuranceChequeItems[${i}][id]`, ch.id)
						formData.append(`assuranceChequeItems[${i}][isChanged]`, ch.isChanged)
						formData.append(`assuranceChequeItems[${i}][fileName]`, ch.fileName)
						formData.append(`assuranceChequeItems[${i}][dueDate]`, ch.dueDate)
						formData.append(`assuranceChequeItems[${i}][chequeNumber]`, ch.chequeNumber)
						formData.append(`assuranceChequeItems[${i}][sayadiId]`, ch.sayadiId)
						formData.append(`assuranceChequeItems[${i}][price]`, ch.price)
					}
				}
				this.submitLoading = true
				api.post('admin/assurance/' + (assurance.id === emptyId ? 'create' : 'edit'), formData, { contentType: 'multipart/form-data' })
					.then(response => {
						assurance.editMode = false
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.loadData()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			},
			cancel(assurance, index) {
				if (assurance.id == emptyId) {
					this.assurances.splice(index, 1)
					return
				}

				assurance.description = assurance.original?.description
				assurance.fileName = assurance.original?.fileName
				assurance.assuranceType = assurance.original?.assuranceType
				assurance.goldWeight = assurance.original?.goldWeight
				assurance.isReturned = assurance.original?.isReturned
				assurance.personFullName = assurance.original?.personFullName
				assurance.personNationalCode = assurance.original?.personNationalCode
				assurance.personalCode = assurance.original?.personalCode
				assurance.returnedToPerson = assurance.original?.returnedToPerson
				assurance.returnDateTime = assurance.original?.returnDateTime
				assurance.organization = assurance.original?.organization
				assurance.assuranceChequeItems = assurance.original?.assuranceChequeItems

				assurance.editMode = false
			},
			async remove(assurance, index) {
				if (!assurance) {
					return
				}

				if (assurance.id == emptyId) {
					this.assurances.splice(index, 1)
					return
				}

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این تضمین مطمئن هستید؟',
				)) {
					api.post('admin/assurance/delete/' + assurance.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.assurances.splice(index, 1)
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			add() {
				let newAssurance = {
					id: emptyId,
					description: '',
					editMode: true,
					assuranceType: 0,
					assuranceChequeItems: []
				}
				this.assurances.push(newAssurance)
			},
			viewImage(img) {
				this.overlay = true
				this.overlayImgSrc = img
			},
			manageOrganizations() {
				this.organizationsDialog = true
			},
			showReturnDialog(assurance) {
				this.selectedReturn = {
					assuranceId: assurance.id,
					isReturned: assurance.isReturned,
					returnDateTime: assurance.returnDateTime === '0001-01-01T00:00:00' ? new Date().toISOString() : assurance.returnDateTime,
					returnedToPerson: assurance.returnedToPerson
				}
				this.returnDialog = true
			},
			submitReturn() {
				if (!this.$refs.returnform.validate())
					return
				this.returnDatePickerValidatioin = ''
				if (!this.selectedReturn.returnDateTime) {
					this.returnDatePickerValidatioin = 'تاریخ عودت را وارد کنید'
					return
				}
				this.submitReturnLoading = true
				this.selectedReturn.isReturned = !!this.selectedReturn.isReturned
				api.post('admin/assurance/SubmitReturn', this.selectedReturn)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							let index = this.assurances.findIndex(x => x.id === this.selectedReturn.assuranceId)
							if (index > -1) {
								this.assurances[index].returnedToPerson = this.selectedReturn.returnedToPerson
								this.assurances[index].returnDateTime = this.selectedReturn.returnDateTime
								this.assurances[index].returnDateTime_Persian = response.returnDateTime_Persian
								this.assurances[index].isReturned = this.selectedReturn.isReturned
							}
							this.returnDialog = false
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => this.submitReturnLoading = false)
			},
			addCheque(assurance) {
				assurance.assuranceChequeItems.push({
					id: emptyId,
					chequeNumber: '',
					sayadiId: '',
					dueDate: '',
					base64: '',
					fileName: '',
					price: 0,
					isChanged: false
				})
			},
			removeChequeItem(assurance, index) {
				assurance.assuranceChequeItems.splice(index, 1)
			},
			print(assurance) {
				this.selectedAssurance = null
				this.printReady = false
				this.printLoadingId = assurance.id
				setTimeout(() => {
					this.selectedAssurance = assurance
					let timer = 0
					let interval = setInterval(() => {
						timer++
						if (timer > 300 || this.printReady) {
							clearInterval(interval)
							this.printLoadingId = ''
						}
						if (this.printReady)
							printJS({
								printable: 'printHtml',
								type: 'html',
								scanStyles: false, // If true inline styles will be removed
								targetStyles: ['*'],
								style: `
										@font-face {
											font-family:'YekanP';
											src:url(/iranyekanweb.woff) format('woff-variations'),
											url(/iranyekanweb.woff) format('woff'),
											url(/iranyekanweb.woff2) format('woff2');
											font-display:fallback
										}
										#printHtml {
												display: block !important;
												font-family: 'YekanP', sans-serif;
										}
									`
							})
					}, 100)
				}, 100)
			},
			sendOTP(mobile, index) {
				if (!mobile) {
					toast.error('شماره موبایل وارد نشده است')
					return
				}
				this.optLoading = true
				api.post('account/SendOTP/' + mobile, {})
					.then(response => {
						this.sendCodeVisible = false
						this.$refs.countdown[index].start()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.optLoading = false
					})
			},
			countDownFinished() {
				this.sendCodeVisible = true
			},
		},
	}
</script>
<style>
	@font-face {
		font-family: 'YekanP';
		src: url('/iranyekanweb.woff') format('woff-variations'),
			url('/iranyekanweb.woff') format('woff'),
			url('/iranyekanweb.woff2') format('woff2');
		font-display: fallback
	}
</style>